import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { FloatingButton } from 'shared/src/api/promotionsService/getPromotionComponents/types';
import { useActiveHomeTab } from './useActiveHomeTab';

/**
 * Home 의 promotion floating button 클릭 로깅.
 * 현재 활성 탭의 screen_name 을 SCREEN 으로 사용.
 */
export const useLogClickHomeFloatingButton = (
  button: FloatingButton,
  buttonIdx: number,
) => {
  const activeTab = useActiveHomeTab();

  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_FLOATING_BUTTON',
      analytics: {
        ...button.logging.analytics,
        BUTTON_INDEX: buttonIdx,
        SCREEN: activeTab?.screen_name ?? 'TODAY',
      },
      ably_only_log: { ...button.logging.ably_only_log },
    });
  }, [button.logging, buttonIdx, activeTab?.screen_name]);
};
